import { render, staticRenderFns } from "./customerservice.vue?vue&type=template&id=63decfb4&scoped=true&"
import script from "./customerservice.vue?vue&type=script&lang=js&"
export * from "./customerservice.vue?vue&type=script&lang=js&"
import style0 from "./customerservice.vue?vue&type=style&index=0&id=63decfb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63decfb4",
  null
  
)

export default component.exports